import { Box, Divider } from '@mui/material';
import { ModuleSelector } from './ModuleSelector.jsx';
import { ModuleInputs } from './ModuleInputs.jsx';
import { useContext } from './context.jsx';

export function Modules() {
  const { focusedModule } = useContext();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'hidden',
      }}
    >
      {focusedModule ? <Divider sx={{ pt: 8 }} /> : null}
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: 2, md: 3 },
          overflow: { xs: 'auto', sm: 'hidden' },
          py: { xs: 2, sm: 3 },
        }}
      >
        <Box sx={{ px: { xs: 2, sm: 3, md: 4, lg: 5 } }}>
          <Box sx={{ maxWidth: 900 }}>
            <ModuleSelector />
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            overflow: { sm: 'auto' },
            px: { xs: 2, sm: 3, md: 4, lg: 5 },
          }}
        >
          <Box sx={{ maxWidth: 900 }}>
            <ModuleInputs />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
